export default {
  CASE_CREATION_INITIATED: 'Case Creation Initiated',
  ADDITIONAL_DOCUMENT_SUBMISSION_INITIATED: 'Additional Document Submission Initiated',
  ADDITIONAL_BANK_SUBMISSION_INITIATED: 'Additional Bank Submission Initiated',
  ADDITIONAL_DOCUMENT_SUBMISSION: 'Additional Document Submitted',
  CASE_CREATION_DOCUMENT_STEP: 'Case Creation Documents Step',
  CASE_DOCUMENT_PREVIOUS_CLICKED: 'Case Document Previous Clicked',
  CASE_DOCUMENT_NEXT_CLICKED: 'Case Document Next Clicked',
  ADDITIONAL_SUBMISSION_PREVIOUS_CLICKED: 'Additional submission previous Button Clicked',
  CASE_NEXT_BUTTON_CLICK: 'Case Next Button Clicked',
  CASE_SEARCH_BANK: 'Case Search bar bank',
  ADDITIONAL_BANK_SUBMITTED: 'Additional Bank Submitted',
  CASE_SUBMITTED: 'Case Submitted',
  CASE_SUBMIT_STEP: 'Case Creation Review and Submit Step',
  CASE_ADDITIONAL_INFORMATION_CLICK: 'Case additional information Clicked',
  CASE_CHECKBOX_CLICK: 'Case Checkbox Clicked',
  CASE_UPLOAD_DOCUMENT_CLICK: 'Case Upload Document Clicked',
  CASE_DOCUMENT_PREVIOUS_CLICK: 'Case Document Previous Clicked',
  CASE_DOCUMENT_NEXT_CLICK: 'Case Document Next Clicked',
  CASE_PREVIOUS_CLICK: 'Case previous Button Clicked',
  PENDING_FORMS_PAGE_LOADED: 'Pending Forms Page Loaded',
  PENDING_FIELDS_SAVED: 'Pending Fields Saved',
  CASE_PENDING_FIELDS_NEXT_CLICKED: 'Case Next Button Clicked Pending Fields Page',

  // New events
  CASE_CREATION_ATTEMPTED: 'Case Creation Attempted',
  CASE_CREATION_COMPLETED: 'Case Creation Completed',
  CASE_CREATION_FAILED: 'Case Creation Failed',

  CASE_BASIC_INFORMATION_SAVE_ATTEMPTED: 'Case Basic Information Save Attempted',
  CASE_BASIC_INFORMATION_SAVE_COMPLETED: 'Case Basic Information Save Completed',
  CASE_BASIC_INFORMATION_SAVE_FAILED: 'Case Basic Information Save Failed',

  CASE_BANK_DOCUMENT_SECTION_VIEWED: 'Case Bank Document Section Viewed',
  CASE_BANK_DOCUMENT_UPLOAD_ATTEMPTED: 'Case Bank Document Upload Attempted',
  CASE_BANK_DOCUMENT_UPLOAD_COMPLETED: 'Case Bank Document Upload Completed',
  CASE_BANK_DOCUMENT_UPLOAD_FAILED: 'Case Bank Document Upload Failed',

  CASE_BANK_FORMS_UPLOAD_ATTEMPTED: 'Case Bank Forms Upload Attempted',
  CASE_BANK_FORMS_UPLOAD_COMPLETED: 'Case Bank Forms Upload Completed',
  CASE_BANK_FORMS_UPLOAD_FAILED: 'Case Bank Forms Upload Failed',

  CASE_BANK_SUBMISSION_SECTION_VIEWED: 'Case Bank Submission Section Viewed',
  CASE_SUBMISSION_ATTEMPTED: 'Case Submission Attempted',
  CASE_SUBMISSION_COMPLETED: 'Case Submission Completed',
  CASE_SUBMISSION_FAILED: 'Case Submission Failed',

  CASE_DIGITAL_BANK_FORM_GENERATION_ATTEMPTED: 'Case Digital Bank Form Generation Attempted',
  CASE_DIGITAL_BANK_FORM_GENERATION_COMPLETED: 'Case Digital Bank Form Generation Completed',
  CASE_DIGITAL_BANK_FORM_GENERATION_FAILED: 'Case Digital Bank Form Generation Failed',

  CASE_DIGITAL_BANK_FORM_VIEW_ATTEMPTED: 'Case Digital Bank Form View Attempted',
  CASE_DIGITAL_BANK_FORM_VIEW_COMPLETED: 'Case Digital Bank Form View Completed',
  CASE_DIGITAL_BANK_FORM_VIEW_FAILED: 'Case Digital Bank Form View Failed',

  CASE_DIGITAL_BANK_FORM_EDIT_ATTEMPTED: 'Case Digital Bank Form Edit Attempted',
  CASE_DIGITAL_BANK_FORM_EDIT_COMPLETED: 'Case Digital Bank Form Edit Completed',
  CASE_DIGITAL_BANK_FORM_EDIT_FAILED: 'Case Digital Bank Form Edit Failed',

  CASE_BANK_DOCUMENT_CATEGORISATION_SAVE_ATTEMPTED: 'Case Bank Document Categorisation Save Attempted',
  CASE_BANK_DOCUMENT_CATEGORISATION_SAVE_COMPLETED: 'Case Bank Document Categorisation Save Completed',
  CASE_BANK_DOCUMENT_CATEGORISATION_SAVE_FAILED: 'Case Bank Document Categorisation Save Failed',

  CASE_FILL_BANK_FORMS_SECTION_VIEWED: 'Case Fill Bank Forms Section Viewed',
  CASE_FILL_BANK_FORMS_SAVED: 'Case Fill Bank Forms Saved',
  CASE_FILL_BANK_FORMS_PROCEEDED: 'Case Fill Bank Forms Proceeded',

  CASE_BANK_TITLE_DEED_UPLOAD_ATTEMPTED: 'Case Bank title deed Upload Attempted',
  CASE_BANK_TITLE_DEED_UPLOAD_COMPLETED: 'Case Bank title deed Upload Completed',
  CASE_BANK_TITLE_DEED_UPLOAD_FAILED: 'Case Bank title deed Upload Failed',
};
